<div class="id-card-wrapper" (click)="emitViewId()">
  @if (sid?.logoUrl) {
  <img alt="" class="id-logo" [src]="getImageUrl(sid?.logoUrl)">
  }
  <div sxRow sxWidth="full" sxDistribution="start" sxGap="10px" sxAlign="center">
    <h1 class="title">{{sid?.name}}</h1>
    @if (document?.sid?.verificationAvailable && !document?.verificationTime) {
    <div sxRow sxTextSize="12px" sxColor="warning" sxAlign="center" sxGap="5px">
      <ion-icon sxTextSize="16px" name="alert-circle"></ion-icon>
      Verify
    </div>
    }
    @if (document?.verificationTime) {
    <img alt="" sxWidth="15px" sxHeight="15px" src="assets/imgs/ver-icon_1.png">
    }
  </div>

  <div class="card-detail">
    @if (document) {
    <div>
      @if (document?.documentNumberMasked) {
      <h1 class="number" sxWidth="full" sxTextAlign="left">
        {{document?.documentNumberMasked}}</h1>
      }
      @if (documentData?.fullName) {
      <h1 class="owner-name">{{documentData?.fullName}}</h1>
      }
      @if (!document?.account && account) {
      <h1 class="owner-name">{{account?.name}}</h1>
      }
    </div>
    }

    @if (sid) {
    <div class="card-options">
      @if (!document || !document._id) {
      <button class="upload-id-button" (click)="emitUpload()">Upload</button>
      }
      @if (!mandatory && document) {
      <ion-checkbox [checked]="true" color="light" (ionChange)="onToggle($event)"></ion-checkbox>
      }
    </div>
    }
  </div>

  @if (isDocumentDeleted) {
  <div sxCol sxGap="10px" sxPadding="medium" sxColor="two">
    <ion-icon name="alert-circle-outline" sxTextSize="30px"></ion-icon>
    <h1 sxTextSize="medium" sxMargin="0">Document Deleted</h1>
  </div>
  }

</div>